import { useRef } from "react";
import { StoryCard } from "./StoryCard";

interface Submission {
  id: number;
  title: string;
  username: string;
  like_count: number;
}

interface PromptSectionProps {
  submissions: Submission[];
  onStoryClick: (id: number) => void;
}

export function PromptSection({ submissions, onStoryClick }: PromptSectionProps) {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: "left" | "right") => {
    if (scrollRef.current) {
      const scrollAmount = 300;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  if (submissions.length === 0) {
    return <p className="no-submissions">No submissions yet. Be the first!</p>;
  }

  return (
    <div className="submissions-container">
      {submissions.length > 3 && (
        <button className="scroll-btn scroll-left" onClick={() => scroll("left")}>
          &lt;
        </button>
      )}
      <div className="submissions-scroll" ref={scrollRef}>
        {submissions.map((submission) => (
          <StoryCard
            key={submission.id}
            id={submission.id}
            title={submission.title}
            username={submission.username}
            likeCount={submission.like_count}
            onClick={() => onStoryClick(submission.id)}
          />
        ))}
      </div>
      {submissions.length > 3 && (
        <button className="scroll-btn scroll-right" onClick={() => scroll("right")}>
          &gt;
        </button>
      )}
    </div>
  );
}
